import StatusTag from '@/components/_common/StatusTag';
import { Card, Col, Row, Statistic, Typography } from 'antd';
import { workorderIndicatorOptions } from '../options';
import formatterPrice from '@/utils/number/formatterPrice';
import { WorkOrderChartFilter } from '@/core/domain/workorder/WorkOrdersChart/WorkOrdersChart.types';
import { useWorkOrderChartIndicators } from '@/core/domain/workorder/WorkOrdersChart/WorkOrdersChart.hooks';

interface Props {
  filter?: WorkOrderChartFilter;
}

export default function WorkOrderIndicatorsAmount(props: Props) {
  const { data, isLoading } = useWorkOrderChartIndicators(props.filter);

  return (
    <div>
      <Typography.Title level={4}>Valor total por status</Typography.Title>

      <Row gutter={[24, 24]}>
        {workorderIndicatorOptions.map((item, i) => (
          <Col key={item.key} span={24} md={12} lg={8} xl={i === 4 ? 4 : 5}>
            <Card bordered style={{ borderRadius: 12 }} loading={isLoading}>
              <Statistic
                title={<StatusTag label={item.label} color={item.color} />}
                value={data ? data[item.key as keyof typeof data] : 0}
                valueStyle={{ fontSize: '1.4rem', paddingTop: 8 }}
                formatter={(value) => formatterPrice(Number(value))}
              />
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
